(function() {
    'use strict';

    angular
        .module('app')
        .controller('myTrainingSelectActionModalController', myTrainingSelectActionModalController);


    function myTrainingSelectActionModalController($uibModalInstance, $interval,
        $uibModal, $scope, $sce, $window, trainingInnerService, $timeout, courseService,
        modalService, $q, viewModel, ctmsService, enumService, $location, loginService,
        $rootScope, commonService, $anchorScroll, _sessionDecaySecs, $http, headerService, mobileService, apiUrl) {
        var DEFAULT_POPUPTIME = 600; //預設10分鐘
        var default_ctmsCourseTimeInterval = 300; //固定回傳時隔，預設5分鐘
        var vm = this;
        var timer, viewTimeInterval, sessionTimeInterval;
        vm.isMobile = modalService.isMobile();
        vm.setPathUrl = setPathUrl;
        vm.cancel = cancel;
        vm.vgPlayReady = vgPlayReady;
        vm.vgComplete = vgComplete;
        vm.actionSubmit = actionSubmit;
        vm.choiceSelectActive = choiceSelectActive;
        vm.returnActiveList = returnActiveList;
        vm.sessionChoice = sessionChoice;
        vm.tabChange = tabChange;
        vm.goTop = goTop;
        vm.setPercentStyle = setPercentStyle;
        vm.enum = {
            courseType: enumService.courseType
        };
        vm.pdfIsDone = false;
        vm.durationView = durationView;
        vm.postToIos = postToIos;
        vm.setSession = setSession;

        var mobile = {
            Android: function() {
                return navigator.userAgent.match(/Android/i);
            },
            BlackBerry: function() {
                return navigator.userAgent.match(/BlackBerry/i);
            },
            iOS: function() {
                return navigator.userAgent.match(/iPhone|iPad|iPod/i);
            },
            Opera: function() {
                return navigator.userAgent.match(/Opera Mini/i);
            },
            Windows: function() {
                return navigator.userAgent.match(/IEMobile/i);
            },
            any: function() {
                return (mobile.Android() || mobile.BlackBerry() || mobile.iOS() || mobile.Opera() || mobile.Windows());
            }
        };



        function durationView() {
            return intConvertTime(vm.view.viewTime);
        }


        //===Main==
        init();
        window.addEventListener("beforeunload", function(event) {

            postLearningRecord(false, true);
            var confirmationMessage = "\o/";
            (e || event).returnValue = confirmationMessage; //Gecko + IE
            return confirmationMessage; //Webkit, Safari, Chrome etc.
        });
        //=========
        function init() {
            dataInit();
            logicInit();

            $scope.$on('goTop', function() {
                goTop();
            });
            $scope.$on('emitExamSubmit', function() {
                postLearningRecord(false, true);
            });
            $scope.$on('$destroy', function() {
                $interval.cancel(viewTimeInterval);
                $interval.cancel(sessionTimeInterval);
                $timeout.cancel(timer);
            });
            // console.log("vm.view.sessionTime", vm.view.sessionTime);
            // console.log("$rootScope.userInfo",$rootScope.userInfo);
            sessionTimeInterval = $interval(function() {
                loginService.checkToken();
                // console.log("sessionTimeInterval checkToken");
            }, vm.view.sessionTime);
        }

        function dataInit() {
            viewModel = viewModel || {};
            vm.timeConfig = viewModel.timeConfig || {};
            vm.data = {
                pdfUrl: "", //............................正在觀看的pdfUrl
                iframeUrl: "", //.........................正在觀看的IframeUrl
                courseItem: null, //......................正在執行的學習動作教材內容(WS3)
                studyActivity: null, //..................正在觀看的學習動作
                importCourse: viewModel.item || null, //.理論上是清單列傳入的班次課程
                courageItem: null, //.....................學程資料
                courageDetail: null, //...................學程詳細資料
                courageActive: null, //...................學程包含學習動作(WS14)
                courageAction: null, //...................學程包含動作(由courageActive抽出整理)
                sessionItem: null, //.....................班次資料
                sessionDetail: null, //...................班次詳細資料
                sessionActives: null, //..................班次包含學習動作(WS14)
                sessionLms: null, //......................班次包含學習項目(由sessionActives加工整理)
                sessionAction: null, //...................班次包含學習動作(由sessionActives抽出整理)
                ctmsTime: vm.timeConfig.ctmsTime /*8*/ || DEFAULT_POPUPTIME, //.........學習項目觀看時，確認繼續課程的顯示倒數計時(秒)
                ctmsCourseTimeInterval: vm.timeConfig.ctmsCourseTimeInterval || default_ctmsCourseTimeInterval, //.........學習項目觀看時，固定回傳時隔

            };
            vm.config = {
                sources: [],
                tracks: [{
                    src: "http://www.videogular.com/assets/subs/pale-blue-dot.vtt",
                    kind: "subtitles",
                    srclang: "en",
                    label: "English",
                    default: ""
                }]
            };
            vm.view = {
                contentCourage: false,
                contentCourse: false,
                isDownload: false,
                isShowPdf: false,
                isShowVideo: false,
                isShowExam: false,
                isShowIframe: false,
                viewTime: 0,
                pageLoad: false,
                sessionTime: 0,
                activeContent: false,
                activeList: false,
                couragePage: false, //.............學程頁面
                sessionPage: false, //.............班次頁面
            };
            vm.vgApi = null;
            vm.tabSelected = 1;
        }

        function logicInit() {
            vm.view.sessionTime = ($rootScope.userInfo.sessionTime <= 3 ? 20 : $rootScope.userInfo.sessionTime) * 60000;
            vm.view.sessionTime -= (1000 * 120); //TODO 不懂為何要減掉。
            vm.view.sessionTime = vm.view.sessionTime || _sessionDecaySecs;
            switch (vm.data.importCourse.courseType) {
                case 7:
                    //學程
                    courageInit(vm.data.importCourse).then(function() {
                        Accordion();
                        vm.view.couragePage = true;
                    });
                    break;
                default:
                    //非學程就直接處理課程資訊
                    sessionInit(vm.data.importCourse).then(function() {
                        Accordion();
                        vm.view.sessionPage = true;
                    });
                    break;
            }
        }

        function courageInit(importItem) {

            vm.data.courageItem = null;
            vm.data.courageDetail = null;
            vm.data.courageActive = null;
            vm.data.courageAction = null;
            if (!importItem) { return; }
            vm.data.courageItem = angular.copy(importItem);
            var selectActive = trainingInnerService.getSelectActive(vm.data.courageItem);
            var courseDetail = trainingInnerService.getCourseDetail(vm.data.courageItem);
            // console.log("translate:", $rootScope.translate);
            return $q.all([selectActive, courseDetail]).then(function(data) {
                var selectActiveResult = data[0];
                var courseDetailResult = data[1];
                vm.data.courageDetail = detailFormat(courseDetailResult);
                vm.data.courageActive = selectActiveResult;
                vm.data.courageAction = actionItemFormat(selectActiveResult.availableActions);
                _.forEach(vm.data.courageDetail.courses, function(courseItem) {
                    if (courseItem.status && courseItem.progress) { return; }
                    trainingInnerService.getSelectActive(courseItem).then(function(data) {
                        courseItem.status = 'get status Error';
                        courseItem.progress = null;
                        if (!data) { return; }
                        courseItem.status = '';
                        courseItem.progress = '';
                        if (data.status) {
                            courseItem.status = statusConvert(data.status);
                        }
                        if (data.progress) {
                            courseItem.progress = data.progress;
                        }
                    });
                });
            });
        }

        function statusConvert(statusCode) {
            //通過狀態的多國語系轉換
            if (!statusCode) { return ''; }
            switch (statusCode + '') {
                case '-1':
                    // return $rootScope.translate.tsunPassStatusValueNotCourage;
                    return '';
                case '0':
                    return $rootScope.translate.tsunPassStatusValueNA;
                case '1':
                    return $rootScope.translate.tsunPassStatusValueExemption;
                case '2':
                    return $rootScope.translate.tsunPassStatusValueOK;
                case '3':
                    return $rootScope.translate.tsunPassStatusValueNotOK;
                default:
                    return '';
            }
        }

        function sessionInit(importItem) {
            vm.data.sessionItem = null;
            vm.data.sessionDetail = null;
            vm.data.sessionActives = null;
            vm.data.sessionAction = null;
            vm.data.sessionLms = null;
            if (!importItem) { return; }
            vm.data.sessionItem = angular.copy(importItem);
            var selectActive = trainingInnerService.getSelectActive(vm.data.sessionItem);
            var courseDetail = trainingInnerService.getCourseDetail(vm.data.sessionItem);
            return $q.all([selectActive, courseDetail]).then(function(data) {
                // console.log('selectActive:', selectActive);
                // console.log('courseDetail:', courseDetail);
                //console.log('data:', data);
                var selectActiveResult = data[0];
                var courseDetailResult = data[1];
                // console.log("selectActiveResult:",selectActiveResult);
                vm.data.sessionDetail = detailFormat(courseDetailResult);
                vm.data.sessionActives = selectActiveResult;
                vm.data.sessionAction = actionItemFormat(selectActiveResult.availableActions);
                vm.data.sessionLms = lmsItemsFormat(vm.data.sessionItem);
            });
        }

        function detailFormat(sourceData) {
            var detailData = angular.copy(sourceData);
            if (!detailData) { return detailData; }
            //===========
            var brCheck = /(\r?\n)/g;
            _.forEach(detailData, function(value, key) {
                var isInt = (value === parseInt(value, 10));
                var isString = (typeof value === "string");
                if (isInt) {
                    var isAsNull = (value < 0);

                    if (isAsNull) {
                        detailData[key] = null;
                    } else {
                        detailData[key] = value + '';
                    }
                } else if (isString) {
                    detailData[key] = value.replace(brCheck, "<br/>");
                }
            });
            //===========
            if (detailData.reference) {
                //檢查參考文件格式
                if (!angular.isArray(detailData.reference)) {
                    //參考文件必須是陣列
                    detailData.reference = null;
                }
                if (detailData.reference.length <= 0) {
                    //參考文件必須有內容
                    detailData.reference = null;
                }
            }
            return detailData;
        }

        function sessionChoice(sessionItem) {
            vm.view.couragePage = false;
            vm.view.sessionPage = true;
            if (!sessionItem.courseType) {
                sessionItem.courseType = 1;
            }
            sessionInit(sessionItem).then(function() {
                vm.tabSelected = 1;
                //console.log("typeof Accordion", typeof Accordion);
                //如果有要製作等待頁面讀取中可以在此實作後續機制
            });
        }

        function setPathUrl(filePath) {
            var pathUrl = commonService.ctmsFilePath(filePath);
            return pathUrl;
        }

        function actionItemFormat(actionList) {
            //---處理Sunnet WS14 availableActions屬性
            var result = [];
            _.forEach(actionList, function(value) {
                var perItem = { name: '', action: '' };
                perItem.action = angular.copy(value);
                switch (value.toLowerCase()) {
                    case "enroll":
                        perItem.name = $rootScope.translate.tsunActionEnroll;
                        break;
                    case "cancel":
                        perItem.name = $rootScope.translate.tsunActionCancel;
                        break;
                    case "leave":
                        perItem.name = $rootScope.translate.tsunActionLeave;
                        break;
                    case "exemption":
                        perItem.name = $rootScope.translate.tsunActionExemption;
                        break;
                    default:
                        perItem.name = value;
                        break;
                }
                result.push(perItem);
            });
            return result;
        }

        function lmsItemsFormat(sessionItem) {
            if (!vm.data.sessionActives) { return; }
            var activeItem = [];
            var perItem;
            //====加入出缺席狀況
            if (sessionItem.courseType === vm.enum.courseType.classCourse ||
                sessionItem.courseType === vm.enum.courseType.externalCourse) {
                perItem = {};
                perItem.isAction = false;
                perItem.itemName = format("【{0}】", $rootScope.translate.tsunAttendanceRate);
                perItem.status = vm.data.sessionActives.attendanceRate + "%";
                perItem.extraInfo = "";
                activeItem.push(angular.copy(perItem));
            }
            //====加入報告繳納資訊
            if (vm.data.sessionActives.reportTotal > 0) {
                perItem = {};
                perItem.isAction = false;
                perItem.itemName = format("【{0}】{1}",
                    $rootScope.translate.tsunReportsInfo,
                    $rootScope.translate.tsunClassReportNote);
                perItem.status = format("{0} / {1}",
                    vm.data.sessionActives.reportSubmitted,
                    vm.data.sessionActives.reportTotal);
                perItem.extraInfo = "";
                activeItem.push(angular.copy(perItem));
            }
            //====加入學習動作
            if (vm.data.sessionActives.lmsItems) {
                _.forEach(vm.data.sessionActives.lmsItems, function(value) {
                    if (value.action) {
                        if (value.action.length < 1) {
                            value.action = null;
                        }
                    }
                    value.isAction = true;
                    activeItem.push(value);
                });
            }

            return activeItem;
        }

        function refreshViewTime() {
            $q.when(viewTimeStop()).then(function() {
                viewTimeStart();
            });
        }

        function viewTimeStart() {
            vm.view.viewTime = 0;
            viewTimeInterval = $interval(function() {
                vm.view.viewTime++;
            }, 1000);
            // console.log("viewTimeInterval", viewTimeInterval);
        }

        function viewTimeStop() {
            $interval.cancel(viewTimeInterval);
            $timeout.cancel(timer);
        }

        function countTimeStart() {
            appCallback('countDown-02_beforeTimer', null);
            timer = $timeout(function() {
                //console.log("timer time out",timer);
                //先改成倒數前送出學習紀錄

                appCallback('countDown-02', null);

                postLearningRecord(false, false);
                confirmForDesktop();
            }, vm.data.ctmsTime * 1000);
            //console.log("timer",timer);
        }

        function confirmForDesktop() {
            if (vm.view.isShowVideo && vm.vgApi) {
                vm.vgApi.pause();
                vm.vgApi.closeFullScreen();
            }
            //======
            var param = {
                SessionId: angular.copy(vm.data.sessionItem.sessionId),
                ItemId: angular.copy(vm.data.studyActivity.itemId),
                Duration: intConvertTime(vm.view.viewTime)
            };
            modalService.selectActionConfirm(vm.timeConfig.ctmsConfirmTime, param)
                .result.then(function(data) {
                    // console.log('before postRecord :',data);
                    // postLearningRecord(false, false);
                    if (data === 'logout') {
                        $uibModalInstance.dismiss('cancel');
                        $location.path('/');
                        return;
                    }
                    refreshViewTime();
                    if (vm.view.isShowVideo) {
                        vm.vgApi.play();
                    }
                    countTimeStart();
                });
        }

        function cancel() {
            if (vm.view.pageLoad) {
                postLearningRecord(false, true);
            }
            // $uibModalInstance.dismiss('cancel');
            $uibModalInstance.close();
        }

        function vgPlayReady(api) {
            vm.vgApi = api;
        }

        function vgComplete() {
            postLearningRecord(true, false);
        }

        function postLearningRecord(alert, reset) {

            //因內嵌網頁需要，多加一個sessionStorage 變數
            if (sessionStorage.getItem('IsLearningRecordCommit') == 'true') {
                if (!vm.data.studyActivity) { return null; }
                if (vm.data.studyActivity.type === '測驗' ||
                    vm.data.studyActivity.type === '問卷') {
                    //測驗與問卷不回傳時數。
                    return;
                }

                var param = {
                    SessionId: angular.copy(vm.data.sessionItem.sessionId),
                    ItemId: angular.copy(vm.data.studyActivity.itemId),
                    Duration: intConvertTime(vm.view.viewTime)
                };

                //console.log("enter postLearningRecord");
                var result = trainingInnerService.postLearningRecord(param, alert);
                result.then((data) => {
                    // toastr.success('ok oh');
                }).catch((reason) => {
                    // chris: log for mobile
                    // toastr.error(JSON.stringify(reason));
                    toastr.error('發送學習記錄失敗');
                });
                if (reset) {
                    vm.data.studyActivity = null;
                }
                // console.log("end postLearningRecord");
            }
        }

        function actionSubmit(enrollTarget, action) {
            // 申請項目呼叫事件
            // 呼叫完畢要重讀頁面資訊

            trainingInnerService.postSessionAction(enrollTarget, action).then(function() {
                if (enrollTarget.courseType === 7) {
                    courageInit(angular.copy(vm.data.courageItem));
                } else {
                    sessionInit(angular.copy(vm.data.sessionItem));
                }
            });
        }


        function initViewState() {
            clearAll();
            if (vm.data.studyActivity) {
                switch (vm.data.studyActivity.type) {
                    case '影片':
                        trainingInnerService.getCourseItems(vm.data.studyActivity).then(function(data) {
                            vm.data.courseItem = data;
                            changeActivityType();
                        });
                        break;
                    case '課程內容':
                        trainingInnerService.getCourseItems(vm.data.studyActivity).then(function(data) {
                            vm.data.courseItem = data;
                            changeActivityType();
                        });
                        break;
                    case '問卷':
                        changeExam();
                        break;
                    case '測驗':
                        changeExam();
                        break;
                    default:
                        break;
                }
            }
        }

        function changeActivityType() {
            var path = (vm.data.courseItem.path || '');
            if (vm.data.courseItem.href && path.length > 0) {
                path = path + '/' + (vm.data.courseItem.href);
            } else if (vm.data.courseItem.href) {
                path = (vm.data.courseItem.href || '');
            } else {
                // path = path;
            }
            path = path.replace("\\", "/");
            var pathUrl = setPathUrl(path);
            vm.data.courseItem.fileUrl = path;
            // console.log("changeActivityType....courseItem:", vm.data.courseItem, "....pathGo:", pathUrl);
            // $q.when(fileExist(pathUrl)).then(function (result) {


            // 取出已觀看時間 + 放於 session storage 中
            // 寫在這邊是因為不只 mp4 會用到，連 html 都會需要這個參數
            let itemId = vm.data.courseItem.id;
            let sessionLm = _.find(vm.data.sessionLms, o => o.itemId === itemId );
            if (sessionLm) {
                let seconds = moment.duration(sessionLm.viewedTime).asSeconds();
                sessionStorage.setItem('CtmsSeekTime', seconds);
                console.log('target sessionLm:', sessionLm);
            }
          

            setSession(vm.data.courseItem); //給內嵌網頁的SessionStorage
            fileExist(vm.data.courseItem).then(function(result) {
                var fileExtension = getFileExtension(pathUrl);
                switch (fileExtension) {
                    //case 'mp4':
                    //    appCallback('countDown-01,' + DEVICE_TYPE, null);
                    //    //if (!(mobile.iOS() && window.webkit)) {
                    //    if (!(mobile.iOS() && window.webkit) || DEVICE_TYPE == 'Android') {
                    //        countTimeStart();
                    //    }
                    //    vm.view.isShowVideo = true;
                    //    vm.vgApi.clearMedia();
                    //    var videos = [];
                    //    vm.accessBegin = moment(new Date()).format('YYYY/MM/DD HH:mm:ss');
                    //    videos.push({
                    //        src: pathUrl,
                    //        type: 'video/mp4'
                    //    });
                    //    vm.config.sources = videos;
                    //    // ready for ios video player
                    //    if (mobile.iOS() && window.webkit) {
                    //        //if(true){
                    //        // pass param to ios and open player
                    //        postToIos(vm.data.courseItem, pathUrl);
                    //        returnActiveList();
                    //    } else {
                    //        $timeout(function() {

                    //            // 從 sessoin storage 取出已觀看時間 
                    //            let ctmsSeekTime = parseInt(sessionStorage.getItem('CtmsSeekTime'));
                    //            ctmsSeekTime = !!ctmsSeekTime ? ctmsSeekTime - 120 : 0;  // 需往前兩分鐘
                    //            if (ctmsSeekTime && ctmsSeekTime > 0) {
                                    
                    //                // 詢問是否從上次結束觀看影片的地方開始撥放 
                    //                // 只有在 Android 裝置上才需要執行的功能
                    //                var seekTimeConfirm = modalService.confrimDialog({
                    //                    confirmContent: $rootScope.translate.displayVideoFromLastView,
                    //                });

                    //                seekTimeConfirm.result.then(function(result) {
                    //                    if (result) {
                    //                        // 跳至特定時間開始看
                    //                        vm.vgApi.seekTime(ctmsSeekTime, false /*byPercent*/);
                    //                    } 

                    //                    // 撥放影片
                    //                    vm.vgApi.play();
                    //                });
                    //            } else {
                    //                // 沒有觀看紀錄，直接撥放影片
                    //                vm.vgApi.play();
                    //            }

                                
                    //        }, vm.vgApi.isReady);
                    //    }
                    //    break;
                    case 'pdf':
                        countTimeStart();
                        //window.open(ctmsService.getStampFile(vm.data.courseItem.path, vm.data.courseItem.name), '_blank');
                        //console.log("path:", vm.data.courseitem.path);
                        //console.log("name:", vm.data.courseitem.name);
                        vm.url = ctmsService.getStampFile(vm.data.courseItem.path, vm.data.courseItem.name);
                        console.log("vm Url:", vm.url);
                        const a = document.createElement('a');
                        const el = document.body.appendChild(a);
                        el.setAttribute('style', 'display: none');
                        el.href = vm.url;
                        el.click();
                        //console.log("pdf pathUrl:", apiUrl.pafUrl);
                        //vm.data.pdfUrl = pathUrl;
                        /*
                            Johnson 做法用於pdf專屬站台，客戶不接受資安解釋。(//10.20.30.155:11001/?pdf=)
                        //vm.data.pathUrl = apiUrl.pafUrl+pathUrl;
                        */
                        //vm.view.isShowPdf = true;
                        //vm.pdfIsDone = true;
                        break;
                    case 'mp4':
                    case 'html':
                    case 'htm': //內容不明
                        //countTimeStart();
                        vm.data.iframeUrl = pathUrl;
                        vm.view.isShowIframe = true;
                        //要把內嵌網頁觀看邏輯補上
                        break;
                    default:
                        //TODO 下載檔案回報時數?太奇怪了，暫時先取消這邊邏輯
                        vm.downloadItem = {
                            path: pathUrl,
                            name: vm.data.courseItem.name
                        };
                        vm.view.isDownload = true;
                        break;
                }
            }, function errorEvent(result) {
                //顯示檔案不存在並結束
                // console.log("errorResult", result);
                //ios不需要後續動作
                tabChange(1);
                return;
            });

        }

        // 問卷
        function changeExam() {
            countTimeStart();
            vm.view.isShowExam = true;
        }

        function clearAll() {
            if (vm.vgApi) {
                vm.vgApi.stop();
            }
            vm.view.isDownload = false;
            vm.view.isShowPdf = false;
            vm.view.isShowVideo = false;
            vm.view.isShowExam = false;
            vm.view.isShowIframe = false;
        }

        function tabChange(index) {
            postLearningRecord(false, true);
            viewTimeStop();
            clearActive();
            switch (index) {
                case 0:
                    //case 2:
                    vm.view.couragePage = true;
                    vm.view.sessionPage = false;
                    if (vm.data.courageItem) {
                        courageInit(angular.copy(vm.data.courageItem)).then(function() {
                            // if (typeof Accordion === 'function') {
                            //     Accordion();
                            // }
                            //如果有要製作等待頁面讀取中可以在此實作後續機制
                        });
                    }
                    break;
                case 1:
                    vm.view.activeList = true;
                    if (vm.data.sessionItem) {
                        sessionInit(angular.copy(vm.data.sessionItem)).then(function() {
                            // if (typeof Accordion === 'function') {
                            //     Accordion();
                            // }
                            //如果有要製作等待頁面讀取中可以在此實作後續機制
                        });
                    }
                    break;
                default:
                    break;
            }
        }

        function clearActive() {
            viewTimeStop();
            postLearningRecord(false, true);
            clearActiveView();
            clearAll();
        }

        function choiceSelectActive(item) {
            clearActive();
            vm.data.studyActivity = angular.copy(item);
            vm.view.pageLoad = true;
            vm.view.activeContent = true;
            initViewState();
            refreshViewTime();
        }

        function goTop() {
            $location.hash('PageTop');
            $anchorScroll();
            $location.hash('');
        }

        function returnActiveList() {
            //學習動作回清單列
            //console.log("returnActiveList");
            clearActive();

            if (vm.data.sessionItem) {
                sessionInit(angular.copy(vm.data.sessionItem)).then(function() {
                    vm.view.activeList = true;
                });
            }
        }

        function clearActiveView() {
            vm.view.activeContent = false;
            vm.view.activeList = false;
        }

        function setPercentStyle(item) {
            var progress;
            var percentage;
            var style = {};
            if (item.progress && item.progress.length > 0) {
                progress = item.progress.split('/');
                if (progress.length < 2) {
                    item.progress = null;
                    progress = ['0', '1'];
                }
            } else {
                item.progress = null;
                progress = ['0', '1'];
            }
            percentage = 100 * (parseFloat(progress[0]) / parseFloat(progress[1]));
            percentage = parseInt(percentage) + '';
            if (percentage === '0') {
                style = { 'display': 'none' };
            } else {
                style = { 'width': percentage + '%' };
            }
            return style;
        }
        // function fileExist(pathUrl) {
        //     var request = new XMLHttpRequest();
        //     request.open('HEAD', pathUrl, false);
        //     request.send();
        //     // console.log("path", pathUrl);
        //     // console.log("request.status", request.status);
        //     return (request.status === 200);
        // }

        function fileExist(item) {
            //console.log("fileExist,source:", item);
            // return $q.when(true);
            return trainingInnerService.checkItem(item);
        }

        function getFileExtension(fileName) {
            var result = (/[.]/.exec(fileName)) ? /[^.]+$/.exec(fileName)[0] : undefined;
            if (result) {
                result = (result + '').toLowerCase();
            }
            // console.log("getFileExtension,result:", result);
            return result;
        }
        //======Jquery====
        function Accordion() {
            $(document).off("click", ".accordion .title");

            $(document).on("click", ".accordion .title", function(j) {
                var dropDown = $(this).closest('.col-sm-12').find('p.acc-info');
                $(this).closest('.accordion').find('p.acc-info').not(dropDown).slideUp();

                if ($(this).hasClass('active')) {
                    $(this).removeClass('active');
                } else {
                    $(this).closest('.accordion').find('a.active').removeClass('active');
                    $(this).addClass('active');
                }

                dropDown.stop(false, true).slideToggle();

                j.preventDefault();
            });
        }


        function postToIos(item, url) {

            let ctmsSeekTime = parseInt(sessionStorage.getItem('CtmsSeekTime'));

            var param = {
                Command: 'playVideo',
                SessionId: angular.copy(vm.data.sessionItem.sessionId),
                ItemId: angular.copy(vm.data.studyActivity.itemId),
                LanguageCode: sessionStorage.getItem('userLang'),
                UserId: $rootScope.userInfo.userAccount,
                Tkn: sessionStorage.getItem('token'),
                FileUrl: url.replace("\\", "/"),
                CtmsTime: vm.data.ctmsTime, //訓練系統timeout 時數
                CtmsConfirmTime: vm.timeConfig.ctmsConfirmTime, //觀看影片時，如遇到timeout，會彈出一確認視窗，這時數就是確認視窗的倒數計時
                CtmsCourseTimeInterval: vm.data.ctmsCourseTimeInterval, //觀看影片固定回傳時隔
                CtmsSeekTime: !!ctmsSeekTime ? ctmsSeekTime : 0 //影片已觀看的秒數
            };
            console.log('postToIos:', param);
            //mobileService.postCourseInfo(param);
            window.webkit.messageHandlers.msgHandler.postMessage(JSON.stringify(param));
            //return param;
        }

        function setSession(item) {
            //console.log('setSession');
            sessionStorage.setItem('sessionId', angular.copy(vm.data.sessionItem.sessionId));
            sessionStorage.setItem('itemId', angular.copy(vm.data.studyActivity.itemId));
            sessionStorage.setItem('userId', $rootScope.userInfo.userAccount);
            sessionStorage.setItem('IsLearningRecordCommit', true);

            // sessionStorage.setItem('sessionId',1);
            // sessionStorage.setItem('itemId',2);
            // sessionStorage.setItem('userId',3);
        }
    }
})();